// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Icon = require('client-v2/common/containers/icons/component')
const { ARTICLE_IS_MIXED_CHANGE_PENDING } = require('client-v2/common/models/article/actions')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('ArticleMixButton')

function ArticleMixButton(props) {
  const { checked, disabled } = props
  const modifiers = getBlockModifiers(checked)
  return (
    tag('button', {
      ref: props.forwardedRef,
      className: classNames(
        props.className,
        'Button', // Inherit styles from `client-v2/common/components/buttons/base.sass`
        'CapsuleButton', // Inherit styles from `client-v2/common/components/buttons/capsule.sass`
        bem.block(modifiers)
      ),
      disabled,
      onClick: props.onClick
    },
      tag(ArticleMixButtonIcons, modifiers),
      tag(ArticleMixButtonLabel, modifiers),
      tag(ArticleMixButtonHoverTip, {
        text: getHoverTipText(modifiers)
      })
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const morePropTypes = require('client-v2/common/utils/prop-types')

  ArticleMixButton.propTypes = {
    // Values
    className: PropTypes.string,
    checked: PropTypes.oneOf([
      true,
      false,
      ARTICLE_IS_MIXED_CHANGE_PENDING
    ]),
    disabled: PropTypes.bool,
    forwardedRef: morePropTypes.domRef,
    // Callbacks
    onClick: PropTypes.func
  }
}

module.exports = ArticleMixButton

// BEM entity element components

function ArticleMixButtonIcons({ unchecked }) {
  if (!unchecked) {
    return null
  }
  return tag([
    tag(Icon, {
      className: bem.element('icon'),
      id: 'plus'
    }),
    tag(Icon, {
      className: bem.element('logotype'),
      id: 'mix-logotype',
      'aria-hidden': false,
      'aria-label': 'Mix'
    })
  ])
}

function ArticleMixButtonLabel({ checked }) {
  if (!checked) {
    return null
  }
  return (
    tag('label', {
      className: bem.element('label')
    },
      'Mixed'
    )
  )
}

function ArticleMixButtonHoverTip({ text }) {
  if (!text) {
    return null
  }
  return (
    tag('div', {
      className: bem.element('hover-tip')
    },
      text
    )
  )
}

// Helper functions

function getBlockModifiers(checked) {
  return {
    checked: checked === true,
    unchecked: checked === false,
    pending: checked === ARTICLE_IS_MIXED_CHANGE_PENDING
  }
}

function getHoverTipText(modifiers) {
  if (modifiers.unchecked) {
    return 'Click to Mix the things you like'
  }
  if (modifiers.checked) {
    return 'Add to a collection'
  }
}
